module.exports = __webpack_public_path__ + "img/12.842ec345.png";